<div class="adf-search-panel-scrollable" data-automation-id="adf-search-panel-container">
    <adf-search-filter *ngIf="hasCustomModels()"
                       class="app-search-settings"
                       [showContextFacets]="false">
    </adf-search-filter>
</div>
